import { useMediaQuery } from '@vueuse/core';

const twVar = (name: string, fallback: string) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
};

const md = twVar('--breakpoint-md', '48rem');
const lg = twVar('--breakpoint-lg', '64rem');

export const isMobile = useMediaQuery(`(max-width: ${md})`);
export const isLg = useMediaQuery(`(min-width: ${lg})`);

export const isTouchDevice = useMediaQuery('(hover: none) and (pointer: coarse)');
